/**
 * 加油单图片上传 - 客户端校验与去重提示工具。
 *
 * 抽出为纯函数模块，方便 Jest 单元测试直接覆盖（避免触碰 antd Upload）。
 */

export const ALLOWED_MIME = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/heic', 'image/heif'];
export const ALLOWED_EXT = ['.png', '.jpg', '.jpeg', '.webp', '.heic', '.heif'];
export const MAX_SIZE_MB = 10;
export const MAX_FILES_PER_BATCH = 20;

/** FR-002 + T34: 命中既有 sha256 时的提示文案表（key = 既有记录 status）。 */
export const DUPLICATE_TIPS = {
    confirmed: { color: 'green', text: '已确认绑定航班' },
    pending_extract: { color: 'blue', text: '已上传，正在识别中' },
    pending_match: { color: 'blue', text: '识别完成，正在匹配中' },
    pending_review: { color: 'orange', text: '已识别完成，请前往审核确认' },
    pending_review_low_confidence: { color: 'orange', text: '识别置信度偏低，请前往审核' },
    pending_review_ambiguous_match: { color: 'orange', text: '存在多个候选航班，请前往审核' },
    failed_permanent: { color: 'red', text: '之前识别失败，可重新识别' },
    rejected: { color: 'volcano', text: '之前已被拒绝，可恢复审核' },
};

/**
 * 校验单个文件是否满足上传要求。
 * @param {File} file
 * @returns {{ ok: boolean, reason?: string }}
 */
export function validateFile(file) {
    if (!file) return { ok: false, reason: 'empty file' };

    const mime = (file.type || '').toLowerCase();
    const ext = '.' + (file.name?.split('.').pop() || '').toLowerCase();
    const isAllowedMime = ALLOWED_MIME.includes(mime);
    const isAllowedExt = ALLOWED_EXT.includes(ext);

    if (!isAllowedMime && !isAllowedExt) {
        return { ok: false, reason: `unsupported format: ${file.name}` };
    }
    if (file.size > MAX_SIZE_MB * 1024 * 1024) {
        return { ok: false, reason: `${file.name} exceeds ${MAX_SIZE_MB} MB` };
    }
    return { ok: true };
}

/**
 * 截断超过单批限制的文件。
 * @param {File[]} files
 * @returns {{ accepted: File[], truncated: number }}
 */
export function truncateBatch(files) {
    if (!Array.isArray(files)) return { accepted: [], truncated: 0 };
    if (files.length <= MAX_FILES_PER_BATCH) return { accepted: files, truncated: 0 };
    return {
        accepted: files.slice(0, MAX_FILES_PER_BATCH),
        truncated: files.length - MAX_FILES_PER_BATCH,
    };
}
